import React from 'react';
import _ from 'lodash';
import cn from 'classnames';
import css from '../Points/Points.scss';

type Props = {
	onMouseDown: (...args: any[]) => any;
	prop: string;
	side: string;
	active?: boolean;
};

const Point = ({ onMouseDown, side, prop, active }: Props) => {
	const _onMouseDown = event => {
		onMouseDown(event, { side, prop });
	};
	return (
		<div
			onMouseDown={_onMouseDown}
			className={cn(css.point, css[`point-${_.kebabCase(side)}`], {
				[css.active]: active,
			})}
		/>
	);
};

Point.defaultProps = {
	active: false,
};

export default Point;
